import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  submitForgot,
  submitReset,
  validateToken,
  validateTokenSet,
} from '../../ducks/forgotActions';
import { fetchLogin, resetLogOut } from '../../../login/ducks/loginActions';
import { registerExistingUser } from '../../../registration/ducks/registrationActions';
import { USER_TYPE } from '../../../registration/components/presentational/IdntyDownloadView';

const useReset = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleFetchUser = () => {
    dispatch(fetchLogin());
  };

  const handleForgot = (values, isIdnty, programId) => (
    dispatch(submitForgot(values, isIdnty, programId))
  );

  // For IDNTY, submitReset skips login - the new password is resent to
  // registerExistingUser, using email/programId from the reset response.
  const handleReset = (values, isIdnty, easyJoinId, programId) => (
    dispatch(submitReset(values, isIdnty)).then((data) => {
      if (isIdnty && data) {
        return dispatch(registerExistingUser({
          authenticationMethod: 'PASSWORD',
          easyJoinId: easyJoinId || process.env.IDNTY_EASY_JOIN_ID,
          email: data.email,
          password: values.password,
          programId: programId || data.programId,
        })).then((result) => {
          // Failure is already toasted by registerExistingUser - just stay
          // put. A reset always implies an existing account, so the success
          // page below is never the "new user" copy.
          if (!result?.success && !result?.alreadyJoined) {
            return;
          }
          const targetProgramId = programId || data.programId;
          const params = new URLSearchParams();
          params.set('userType', result?.alreadyJoined
            ? USER_TYPE.ALREADY_JOINED
            : USER_TYPE.EXISTING_USER);
          if (targetProgramId) {
            params.set('programId', targetProgramId);
          }
          const queryString = params.toString();
          history.push(`/signup/idnty/success${queryString ? `?${queryString}` : ''}`);
        });
      }
      return data;
    })
  );

  const handleResetLogOut = () => {
    dispatch(resetLogOut());
  };

  const handleValidate = (values) => {
    dispatch(validateToken(values));
  };

  const handleValidateSet = (values) => {
    dispatch(validateTokenSet(values));
  };

  return {
    handleFetchUser,
    handleForgot,
    handleReset,
    handleResetLogOut,
    handleValidate,
    handleValidateSet,
  };
};

export default useReset;
